import { getActivityLogs } from '../../../../../HttpRequests/activityLogs'
import { getProps } from '../../../props'
import { loadProject } from '../../../State/project'
import { setActivityPagination } from '../../../State/activityPagination'
import { setActivityFetching } from '../../../State/activityFetching'
import handleException from '../../../../../Core/Helpers/handleException'

export default (page = 1, pageSize = 10) => async (dispatch, getState) => {

  try {
    const { id } = getProps().match.params
    const project = getState().screens.ProjectView.project

    dispatch(setActivityFetching(true))

    const response = await getActivityLogs({
      params: {
        project_id: id,
        include: 'causer',
        page: page,
        per_page: pageSize
      }
    })

    dispatch(loadProject({
      ...project,
      audit_trail: response.data.data
    }))

    dispatch(setActivityPagination({
      pageNumber: response.data.meta.current_page,
      pageSize: response.data.meta.per_page,
      total: response.data.meta.total
    }))

    dispatch(setActivityFetching(false))

  } catch (error) {
    dispatch(setActivityFetching(false))
    handleException(error)
  }

}
